import React from "react";
import { Table, Input } from "reactstrap";
import styles from "./PricingTable.module.scss";

const PricingTable = () => {
  return (
    <div className={`table-responsive`}>
      <Table bordered className={styles.table}>
        <thead>
          <tr>
            <th rowSpan="2">Features</th>
            <th colSpan="5" className="text-center">
              Packaging Material
            </th>
          </tr>
          <tr>
            <th>Boxes</th>
            <th>Bubble Wrap</th>
            <th>Tape</th>
            <th>Bags</th>
            <th>Labels</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={`${styles["bg-gray"]}`}>
              <div className={`${styles.center}`}>Available Sizes</div>
            </td>
            <td>
              <div className="d-flex gap-2">
                <div>
                  <div>Small</div>
                  <div>Medium</div>
                  <div>Large</div>
                </div>
                <div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div className="d-flex gap-2">
                <div>
                  <div>10m</div>
                  <div>20m</div>
                  <div>50m</div>
                </div>
                <div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div className="d-flex gap-2">
                <div>
                  <div>Standard</div>
                  <div>Heavy-Duty</div>
                </div>
                <div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div className="d-flex gap-2">
                <div>
                  <div>Small</div>
                  <div>Large</div>
                  <div>Extra-Large</div>
                </div>
                <div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div className="d-flex gap-2">
                <div>
                  <div>Standard</div>
                  <div>Custom-Printed</div>
                </div>
                <div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                  <div>
                    <Input type="checkbox" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td className={`${styles["bg-gray"]}`}>
              <div className={styles.center}>Price Per Unit</div>
            </td>
            <td>
              $2 <br /> $3 <br /> $5
            </td>
            <td>
              $1 <br /> $2 <br /> $4
            </td>
            <td>
              $0.50 <br /> $1
            </td>
            <td>
              $1 <br /> $2 <br /> $3
            </td>
            <td>
              $0.20 <br /> $0.50
            </td>
          </tr>
          <tr>
            <td className={`${styles["bg-gray"]}`}>
              <div className={styles.center}>Quantity</div>
            </td>
            <td>
              <Input type="number" className="form-control" placeholder="100" />
            </td>
            <td>
              <Input type="number" className="form-control" placeholder="100" />
            </td>
            <td>
              <Input type="number" className="form-control" placeholder="100" />
            </td>
            <td>
              <Input type="number" className="form-control" placeholder="100" />
            </td>
            <td>
              <Input type="number" className="form-control" placeholder="100" />
            </td>
          </tr>
          <tr>
            <td className={`${styles["bg-gray"]}`}>
              <div className={styles.center}>Total Price (Dynamic)</div>
            </td>
            <td>$20</td>
            <td>$20</td>
            <td>$20</td>
            <td>$20</td>
            <td>$20</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default PricingTable;